import { Switch, Tooltip } from 'antd'
import { SwitchChangeEventHandler } from 'antd/es/switch'
import { useCallback } from 'react'
import styled from 'styled-components'

export const EnableAlertRuleSwitch = ({
  alertKey,
  alertRules,
  setAlertRules,
  cannotEnable,
  ariaLabel
}) => {
  if (!alertRules[alertKey]) {
    return null
  }

  return (
    <EnableSwitch
      checked={alertRules[alertKey].isEnabled}
      disabled={!alertRules[alertKey].isEnabled && cannotEnable}
      ariaLabel={ariaLabel}
      id={`${alertKey}EnableSwitch`}
      onChange={() => {
        const updatedAlertRules = {
          ...alertRules,
          [alertKey]: {
            ...alertRules[alertKey],
            isEnabled: !alertRules[alertKey].isEnabled
          }
        }
        setAlertRules(updatedAlertRules)
      }}
    />
  )
}

export const EnableSwitch = ({
  checked,
  disabled,
  ariaLabel,
  id,
  overrideLabel,
  onChange
}: {
  checked: boolean
  disabled: boolean
  ariaLabel?: string
  id: string
  overrideLabel?: string | null
  onChange: SwitchChangeEventHandler
}) => {
  const defaultLabel = 'Enable alert'
  const noHtmlLabel = overrideLabel === null

  const renderSwitch = useCallback(() => {
    const SwitchElement = (
      <Switch
        id={id}
        checked={checked}
        disabled={disabled}
        aria-label={ariaLabel ?? overrideLabel ?? defaultLabel}
        onChange={onChange}
        size={'small'}
        style={noHtmlLabel ? { marginTop: '2px' } : {}} // small hack to align with multi-line label
      />
    )

    return disabled ? (
      <Tooltip title="You've reached your alert limit. Contact our team to upgrade and enable more alerts.">
        <span>{SwitchElement}</span>
      </Tooltip>
    ) : (
      SwitchElement
    )
  }, [ariaLabel, checked, disabled, id, noHtmlLabel, onChange, overrideLabel])

  if (noHtmlLabel) {
    return renderSwitch()
  }

  return (
    <StyledSwitchWrapper>
      {renderSwitch()}
      <label htmlFor={id} style={{ cursor: 'pointer' }}>
        {overrideLabel ?? defaultLabel}
      </label>
    </StyledSwitchWrapper>
  )
}

const StyledSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`
